<div
  class="tw-mt-10 md:tw-w-full
  {{ isFullWidth ? 'tw-w-full' : 'tw-w-1/2' }}"
>
  <ng-content></ng-content>
</div>
